<template>
  <svg
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_40002730_3654"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="27"
    >
      <path
        d="M21.1397 26.9888H1.86029C0.832882 26.9888 0 26.1573 0 25.1316V2.84591C0 1.82024 0.832882 0.98877 1.86029 0.98877H14.375L23 9.59916V25.1316C23 26.1573 22.1671 26.9888 21.1397 26.9888Z"
        fill="url(#paint0_linear_40002730_3654)"
      />
    </mask>
    <g mask="url(#mask0_40002730_3654)">
      <path
        d="M21.1397 26.9888H1.86029C0.832882 26.9888 0 26.1573 0 25.1316V2.84591C0 1.82024 0.832882 0.98877 1.86029 0.98877H14.375L23 9.59916V25.1316C23 26.1573 22.1671 26.9888 21.1397 26.9888Z"
        fill="url(#paint1_linear_40002730_3654)"
      />
      <path
        d="M3.6655 16.309H5.2895C5.74283 16.309 6.14817 16.3677 6.5055 16.485C6.86817 16.6023 7.17483 16.7837 7.4255 17.029C7.6815 17.269 7.87617 17.573 8.0095 17.941C8.14817 18.309 8.2175 18.7437 8.2175 19.245C8.2175 19.741 8.14817 20.1757 8.0095 20.549C7.87617 20.9223 7.68417 21.2343 7.4335 21.485C7.18817 21.7303 6.8895 21.917 6.5375 22.045C6.1855 22.1677 5.79083 22.229 5.3535 22.229H3.6655V16.309ZM5.2175 21.277C5.49483 21.277 5.74283 21.2397 5.9615 21.165C6.1855 21.085 6.37483 20.965 6.5295 20.805C6.68417 20.6397 6.8015 20.429 6.8815 20.173C6.96683 19.917 7.0095 19.6077 7.0095 19.245C7.0095 18.8823 6.96683 18.5757 6.8815 18.325C6.8015 18.069 6.68417 17.8637 6.5295 17.709C6.37483 17.549 6.1855 17.4343 5.9615 17.365C5.74283 17.2903 5.49483 17.253 5.2175 17.253H4.8495V21.277H5.2175ZM11.7284 22.341C11.3338 22.341 10.9738 22.2717 10.6484 22.133C10.3284 21.989 10.0511 21.7837 9.81644 21.517C9.58177 21.245 9.40044 20.9197 9.27244 20.541C9.14444 20.157 9.08044 19.725 9.08044 19.245C9.08044 18.765 9.14444 18.3357 9.27244 17.957C9.40044 17.5783 9.58177 17.2583 9.81644 16.997C10.0511 16.7357 10.3284 16.5383 10.6484 16.405C10.9738 16.2663 11.3338 16.197 11.7284 16.197C12.1178 16.197 12.4751 16.2663 12.8004 16.405C13.1258 16.5437 13.4058 16.7437 13.6404 17.005C13.8751 17.261 14.0564 17.5783 14.1844 17.957C14.3124 18.3357 14.3764 18.765 14.3764 19.245C14.3764 19.725 14.3124 20.157 14.1844 20.541C14.0564 20.9197 13.8751 21.245 13.6404 21.517C13.4058 21.7837 13.1258 21.989 12.8004 22.133C12.4751 22.2717 12.1178 22.341 11.7284 22.341ZM11.7284 21.317C11.9471 21.317 12.1444 21.269 12.3204 21.173C12.5018 21.077 12.6538 20.9383 12.7764 20.757C12.9044 20.5757 13.0004 20.357 13.0644 20.101C13.1338 19.845 13.1684 19.5597 13.1684 19.245C13.1684 18.605 13.0378 18.1063 12.7764 17.749C12.5204 17.3917 12.1711 17.213 11.7284 17.213C11.2858 17.213 10.9338 17.3917 10.6724 17.749C10.4164 18.1063 10.2884 18.605 10.2884 19.245C10.2884 19.5597 10.3204 19.845 10.3844 20.101C10.4538 20.357 10.5498 20.5757 10.6724 20.757C10.8004 20.9383 10.9524 21.077 11.1284 21.173C11.3098 21.269 11.5098 21.317 11.7284 21.317ZM17.9487 22.341C17.5754 22.341 17.2234 22.2743 16.8927 22.141C16.562 22.0077 16.274 21.813 16.0287 21.557C15.7834 21.301 15.5887 20.9837 15.4447 20.605C15.306 20.2263 15.2367 19.789 15.2367 19.293C15.2367 18.8077 15.3087 18.373 15.4527 17.989C15.602 17.605 15.802 17.2797 16.0527 17.013C16.3034 16.7463 16.594 16.5437 16.9247 16.405C17.2607 16.2663 17.6154 16.197 17.9887 16.197C18.3674 16.197 18.7034 16.2743 18.9967 16.429C19.29 16.5783 19.5327 16.7543 19.7247 16.957L19.1007 17.709C18.9514 17.565 18.7887 17.4477 18.6127 17.357C18.4367 17.261 18.2367 17.213 18.0127 17.213C17.7887 17.213 17.5807 17.261 17.3887 17.357C17.1967 17.4477 17.0314 17.581 16.8927 17.757C16.754 17.933 16.6447 18.1463 16.5647 18.397C16.4847 18.6477 16.4447 18.933 16.4447 19.253C16.4447 19.573 16.4794 19.861 16.5487 20.117C16.6234 20.373 16.7274 20.5917 16.8607 20.773C16.9994 20.949 17.162 21.085 17.3487 21.181C17.5407 21.2717 17.754 21.317 17.9887 21.317C18.2447 21.317 18.4714 21.2637 18.6687 21.157C18.8714 21.045 19.0527 20.9037 19.2127 20.733L19.8367 21.469C19.5914 21.757 19.3114 21.9757 18.9967 22.125C18.682 22.269 18.3327 22.341 17.9487 22.341Z"
        fill="white"
      />
      <g filter="url(#filter0_d_40002730_3654)">
        <path
          d="M23 9.59916H16.375C15.2704 9.59916 14.375 8.70373 14.375 7.59916V0.98877L23 9.59916Z"
          fill="url(#paint2_linear_40002730_3654)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_40002730_3654"
        x="-8.625"
        y="-23.0112"
        width="58.625"
        height="58.6104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="2"
          dy="1"
        />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_40002730_3654"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_40002730_3654"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40002730_3654"
        x1="11.5"
        y1="0.98877"
        x2="11.5"
        y2="26.9888"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7979" />
        <stop
          offset="1"
          stop-color="#E85555"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_40002730_3654"
        x1="11.5"
        y1="0.98877"
        x2="11.5"
        y2="26.9888"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6ABDF8" />
        <stop
          offset="1"
          stop-color="#008BD6"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_40002730_3654"
        x1="18.6875"
        y1="0.98877"
        x2="18.6875"
        y2="9.59916"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#009FE3" />
        <stop
          offset="1"
          stop-color="#0087C1"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
